import { boxShadowButton, label, orange, primary, white } from 'styles'

import { makeStyles } from '@mui/styles'

export default makeStyles({
  rootToggleButton: {
    '&&&&': {
      '&:not(:last-child)': {
        marginRight: '1rem',
      },
      border: 'none',
      borderRadius: '1rem',
      boxShadow: 'none',
      color: primary,
      fontSize: '1rem',
      fontWeight: '600',
      paddingBottom: '0.2rem',
      paddingTop: '0.2rem',
      textTransform: 'capitalize',
    },
  },
  selectedToggleButton: {
    '&&&&': {
      backgroundColor: orange,
      color: white,
    },
  },
  toggleButtonGroup: {
    '&&': {
      backgroundColor: label,
      borderRadius: '1rem',
      boxShadow: boxShadowButton,
      padding: '0.2rem',
    },
  },
})
